import axiosApi from "../../components/Api/Axios";
import CertificationBody from "../../Models/Office/CertificationBody";
import BackendServices from "../../components/Api/BackendService";

export default (id: string | number) =>
  axiosApi.get<CertificationBody>(
    `${BackendServices.CERTIFICATION_SERVICE.CERTIFICATION_BODY}/${id}`
  );
